import {
  NotificationQueueItem,
  NotificationQueueItemDto
} from './notification-queue.models';

export function mapNotificationQueueItem(
  dto: NotificationQueueItemDto
): NotificationQueueItem
{
  return {
    id: dto.id,
    channel: dto.channel ?? 'email',
    eventType: dto.eventType,
    entityType: dto.entityType,
    entityId: dto.entityId,
    recipientEmail: dto.recipientEmail,
    payloadJson: dto.payloadJson,
    status: dto.status,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt
  };
}
